import { styled } from '@mui/material';

import { Button } from '@intelliarts/react-components';

import GoogleIcon from './icons/googleIcon.svg?react';
import { useGoogleAuthLogin } from './googleLoginButtonUtils';

const StyledGoogleIcon = styled(GoogleIcon)({
  marginRight: 15,
  marginTop: 5,
  marginBottom: 5
});

type GoogleLoginButtonProps = {
  onFailure: (error: unknown) => void,
  onUserLoggedIn: () => void,
  onLoadingChange?: (isLoading: boolean) => void
}

export default function GoogleLoginButton({ onFailure, onUserLoggedIn, onLoadingChange }: GoogleLoginButtonProps) {
  const googleLogin = useGoogleAuthLogin(onFailure, onUserLoggedIn, onLoadingChange);
  return (
    <Button
      startIcon={<StyledGoogleIcon />}
      variant="outlined"
      size="large"
      onClick={googleLogin}
    >
      Google
    </Button>
  );
}
